module.exports = [{"id":0,"name":"Comercial Investment"},{"id":1,"name":"Comercial Leasing"},{"id":2,"name":"Corporate News & Career"},{"id":3,"name":"Finance & Valuation"},{"id":4,"name":"Offices & Industial Workspace"},{"id":5,"name":"Planning & Development"},{"id":6,"name":"Research"},{"id":7,"name":"Residential Investment"},{"id":8,"name":"Retail & Leisure"},{"id":9,"name":"Rural & Energy"}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/news/categories.json
// module id = gQ3W
// module chunks = 0